type ShareLinkBoxProps = {
  link: string;
  copied: boolean;
  onCopy: () => void;
  copyLabel: string;
  copiedLabel: string;
};

export default function ShareLinkBox({
  link,
  copied,
  onCopy,
  copyLabel,
  copiedLabel,
}: ShareLinkBoxProps) {
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1 bg-gray-50 border border-gray-200 rounded-lg px-4 py-3 text-sm text-gray-600 truncate">
        {link}
      </div>
      <button
        onClick={onCopy}
        className={`flex items-center gap-1.5 px-4 py-3 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
          copied
            ? "bg-emerald-500 text-white"
            : "bg-indigo-500 hover:bg-indigo-600 text-white"
        }`}
      >
        <i className={copied ? "ri-check-line" : "ri-file-copy-line"}></i>
        {copied ? copiedLabel : copyLabel}
      </button>
    </div>
  );
}
